import { useFlags } from 'flagsmith/react';

export default function useShowInjectionTracker() {
  const { show_injection_tracker } = useFlags(['show_injection_tracker']);

  return !!show_injection_tracker?.enabled;
}
